import Decimal from 'decimal.js';

/**
 * Yes-side probability (0–1) from a market's cents prices: a settled result
 * is certainty, else the last trade price, else a two-sided book's mid for
 * markets that have never traded; null when nothing is usable. Last trade
 * comes first so the hub agrees with the event page's price-history chart,
 * which plots trade prices — on thin books (0.1¢ bid vs 95¢ ask) the mid is
 * meaningless and diverged wildly from the chart. The single pricing policy
 * shared by the race-market math (./raceMarketMath.ts) and the client
 * live-quote overlay (./chamberControl.ts), so the overlay can never
 * disagree with the snapshot it refines.
 */
export function yesProbabilityFromCents(market: {
    result?: string | null;
    bid: number;
    ask: number;
    last: number;
}): number | null {
    if (market.result === 'yes') return 1;
    if (market.result === 'no') return 0;
    const { bid, ask, last } = market;
    if (last > 0) return new Decimal(last).div(100).toNumber();
    if (bid > 0 && ask > 0 && ask < 100) return new Decimal(bid).plus(ask).div(200).toNumber();
    return null;
}
